export default () => {
  return process.env.REACT_APP_FTR_API_URL;
};
